export default __webpack_public_path__ + "static/media/Isometric_Square_turquoise.561b4571.svg";